'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import SearchResultsController from './search-results.controller';
import CommonDataService from '../../common/common-data.service';
import ProductService from '../../products/product-detail/product.service';
import feedback from '../../../components/feedback';
import productCard from '../../../components/product-card';
import { FilterModule } from '../filter/filter.module';
export default angular.module('eeComUiApp.searchResults', [
    ngMaterial,
    'dropdownToggle',
    feedback,
    productCard,
    FilterModule
])
    .controller('SearchResultsController', SearchResultsController)
    .service('ProductService', ProductService)
    .service('CommonDataService', CommonDataService)
    .name;
//# sourceMappingURL=index.js.map